import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wmmp",
  "use": "icon-wmmp-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" class=\"icon\" id=\"icon-wmmp\">\r\n  <path id=\"icon-wmmp_机器\" class=\"cls-1\" d=\"M391.506,406.219h-7.087a0.482,0.482,0,0,1,0-.964h7.087A0.482,0.482,0,0,1,391.506,406.219ZM393.523,409h-11.05a2.486,2.486,0,0,1-2.476-2.49V393.491a2.486,2.486,0,0,1,2.476-2.49h11.05a2.486,2.486,0,0,1,2.476,2.49v13.016A2.486,2.486,0,0,1,393.523,409Zm-11.05-17.032a1.523,1.523,0,0,0-1.517,1.526v13.016a1.523,1.523,0,0,0,1.517,1.526h11.05a1.523,1.523,0,0,0,1.518-1.526V393.491a1.523,1.523,0,0,0-1.518-1.526h-11.05Zm10.934,11.192h-10.89a0.48,0.48,0,0,1-.479-0.482V394.06a0.48,0.48,0,0,1,.479-0.482h10.89a0.481,0.481,0,0,1,.48.482v8.615A0.481,0.481,0,0,1,393.407,403.157ZM383,402.193h9.932v-7.651H383v7.651Z\" transform=\"translate(-380 -391)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wmmp.svg
// module id = 1yqL
// module chunks = 127